module.exports = __webpack_public_path__ + "img/tshirt.71bbbb2b.png";